import { React, useState } from 'react'
import { Link } from 'react-router-dom'
import { Dropdown } from 'react-bootstrap'
import { FiChevronDown, FiChevronUp } from 'react-icons/fi'
import { AiOutlineHistory } from 'react-icons/ai'
import { SiBinance } from 'react-icons/si'
import { CgArrowsExchangeAltV } from 'react-icons/cg'
import { BsChevronRight } from 'react-icons/bs'
import FastMenu from './FastMenu'
import SelectToken from './SelectToken'


export default function Swap() {

    const [state, setstate] = useState(0)
    const [priceRoute, setpriceRoute] = useState(0)
    const [pop, setPop] = useState(0)

    return (
        <>
            {pop == 1 && <SelectToken passState={setPop} />}
            <div className="container pt-lg-5 pt-3">
                <div className="d-flex justify-content-center align-items-center">
                    <div className="ws-tabs">
                        <Link to='/swap' className="active">Swap</Link>
                        <Link to='/liquidity'>Liquidity</Link>
                        <Link to='/Bridge'>Bridge</Link>
                    </div>
                </div>
                <div className="row mx-0 mt-4 justify-content-center">
                    <div className="col-lg-6 px-0">
                        <div className="card g-card px-lg-3 py-3">
                            <div className="card-body">
                                <div className="d-flex justify-content-between  ">
                                    <p className="mb-0">Swap Tokens</p>
                                    <div className="d-flex align-items-center">
                                        <span className="pe-2">Sounds</span>
                                        <label className="switch">
                                            <input type="checkbox" />
                                            <span className="slider round"></span>
                                        </label>
                                    </div>
                                </div>
                                <FastMenu />
                                <div className="d-flex flex-column">
                                    <div className={state == 1 ? "ws-exchange-card  mt-3 order-2" : "ws-exchange-card active mt-3 order-0"}>
                                        <span className="text-faded text-small text-uppercase pb-2">From</span>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="d-flex align-items-center">
                                                <div className="coin-icon" >
                                                    <SiBinance />
                                                </div>
                                                {/* <Dropdown>
                                                    <Dropdown.Toggle id="dropdown-basic">
                                                        BNB
                                                    </Dropdown.Toggle>

                                                    <Dropdown.Menu>
                                                        <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
                                                        <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
                                                        <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </Dropdown> */}
                                                <span className='fs-6 ps-2' onClick={()=>{setPop(1); window.scrollTo(0,0)}}>BNB</span>

                                            </div>
                                            <div>0.982378</div>
                                        </div>
                                        <div className="d-flex justify-content-between align-items- pt-2">
                                            <span className="text-faded text-small text-uppercase">BNB</span>
                                            <span className="text-faded text-small text-uppercase">~$421.92</span>
                                        </div>
                                    </div>
                                    <div className="exchange-btn order-1">
                                        <div>
                                            <span onClick={() => { state == 0 ? setstate(1) : setstate(0) }}>
                                                <CgArrowsExchangeAltV />
                                            </span>
                                        </div>
                                    </div>
                                    <div className={state == 1 ? "ws-exchange-card active mt-3 order-0" : "ws-exchange-card mt-3 order-2"}>
                                        <span className="text-faded text-small text-uppercase pb-2">To</span>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="d-flex align-items-center">
                                                <div className="coin-icon">
                                                    <SiBinance />
                                                </div>
                                                {/* <Dropdown>
                                                    <Dropdown.Toggle id="dropdown-basic">
                                                        Select
                                                    </Dropdown.Toggle>

                                                    <Dropdown.Menu>
                                                        <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
                                                        <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
                                                        <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </Dropdown> */}
                                                <span className='fs-6 ps-2' onClick={()=>{setPop(1); window.scrollTo(0,0)}}>Select</span>
                                            </div>
                                            <div>0.0</div>
                                        </div>
                                    </div>
                                </div>

                                <div className="d-flex align-items-center">

                                </div>

                                <div className="d-flex align-items-center justify-content-between py-4 pb-1">
                                    <div className="d-flex flex-column">
                                        <span className='text-small '>Price</span>
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <span className="text-uppercase d-flex align-items-center text-faded text-small fw-600 ">0.07bnb for busd <img src={process.env.PUBLIC_URL + "assets/images/repeat.png"} style={{ width: "18px" }} alt="" className='ms-2' /></span>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center">
                                    <span className="  pointer" onClick={() => priceRoute == 1 ? setpriceRoute(0) : setpriceRoute(1)}> ROUTE  {priceRoute == 0 ? <FiChevronDown className='fs-5' /> : <FiChevronUp className='fs-5' />}  </span>
                                </div>
                                {priceRoute == 1 &&
                                    <div className="ws-dark-bg rounded-2 p-3" >
                                        < div className="d-flex align-items-center justify-content-between py-4 pt-2">
                                            <div className="d-flex align-items-center">
                                                <div className="coin-icon" >
                                                    <SiBinance />
                                                </div>
                                                <div className="d-flex flex-column align-items-start ps-3">
                                                    <span className=" text-small  text-uppercase">100%</span>
                                                    <span className=" text-small text-faded text-uppercase  d-flex align-items-center">0.023828 <BsChevronRight /></span>
                                                    <span className=" text-small  text-uppercase">-$3849</span>
                                                </div>
                                            </div>
                                            <div className="coin-icon coin-center" >
                                                <SiBinance />
                                            </div>
                                            <div className="d-flex align-items-center">

                                                <div className="d-flex flex-column align-items-end pe-3">
                                                    <span className=" text-small  text-uppercase">100%</span>
                                                    <span className=" text-small text-faded text-uppercase  d-flex align-items-center"> <BsChevronRight className="me-2" /> 0.023828 </span>
                                                    <span className=" text-small  text-uppercase">-$3849</span>
                                                </div>
                                                <div className="coin-icon" >
                                                    <SiBinance />
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div className="d-flex align-items-end justify-content-between pt-0 py-4">
                                    <div className="d-flex align-items-start flex-column ps-5">
                                        <span className=" text-small text-faded text-uppercase ">0.237283 BNB</span>
                                        <span className=" text-small  text-uppercase pt-2 ">-$78.23</span>
                                    </div>
                                    <div className="d-flex align-items-end flex-column">
                                        <span className=" text-small text-faded text-uppercase ">0.237283 BNB</span>
                                        <span className=" text-small  text-uppercase pt-2 ">-$78.23</span>
                                    </div>
                                </div> */}

                                    </div>
                                }


                                <div className="d-flex align-items-center justify-content-between pt-3 pb-1">
                                    <div className="d-flex  ">
                                        <span className=" text-small   ">Price impact</span>
                                    </div>
                                    <div className="d-flex  ">
                                        <span className=" text-small   ">0.05%</span>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center justify-content-between  pt-0">
                                    <div className="d-flex  ">
                                        <span className=" text-small   ">Swap fee</span>
                                    </div>
                                    <div className="d-flex  ">
                                        <span className=" text-small   ">0.05%</span>
                                    </div>
                                </div>


                                <div className="d-flex align-items-center justify-content-between py-4 border-bottom">
                                    <div className="d-flex align-items-start flex-column">
                                        <span className=" text-small ">Slippage tolerance</span>
                                    </div>
                                    <div className="d-flex align-items-end flex-column">
                                        <div className="d-flex align-items-center">
                                            <input className="harvest text-uppercase text-faded-3 ms-2" defaultValue='0.1' style={{ width: "50px" }} />
                                            <input className="harvest text-uppercase text-faded-3 ms-2" defaultValue='0.6' style={{ width: "50px" }} />
                                            <input className="harvest text-uppercase text-faded-3 ms-2" defaultValue='1' style={{ width: "50px" }} />
                                            <input className="harvest text-uppercase text-faded-3 ms-2 me-2" defaultValue='0.00' style={{ width: "60px" }} />
                                            <span className=" text-small ">%</span>
                                        </div>
                                    </div>

                                </div>
                                <span className=" text-small text-uppercase text-faded pt-3">recent transaction</span>
                                <div className="d-flex justify-content-center pt-4" >
                                    <button className="g-btn">Connect wallet</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}
